import script from "./OrgUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrgUser.vue?vue&type=script&setup=true&lang=ts"

import "./OrgUser.vue?vue&type=style&index=0&id=536e957a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-536e957a"]])

export default __exports__